/* globals $ */
import Component from './component';
import fromHtml from '../utils/from-html';

/* eslint-disable react/prefer-stateless-function, react/sort-comp */

const defaults = {};

export default class Filter extends Component {
  constructor($context, options) {
    super(defaults, options);

    this.$context = $context;

    const {
        searchResult
    } = fromHtml(this.$context[0], { removeRefAttribute: false });

    this.$searchResult = $(searchResult);
  }

  getResults(url, value = '') {
    if (this.$context.hasClass('loading')) {
        return false;
    }

    this.toggleLoader(true);

    return $.get(url + value, null, 'html')
        .then(this.appendResults.bind(this));
  }

  toggleLoader(stan = false) {
    this.$context.toggleClass('loading', stan);
  }

  appendResults(re) {
    this.toggleLoader(false);

    this.$searchResult.html(re);
  }

  static initialize(selector = '.js-filter', ClassName = Filter, ClassNameString = 'Filter', $context = $(document.body), options = {}) {
    return super.initialize(selector, ClassName, ClassNameString, $context, options);
  }
}



// WEBPACK FOOTER //
// ./front/bankomania/js/components/filter.js